module.exports = __webpack_public_path__ + "img/SharpnessEnhancement03.3058eed4.png";